import React from 'react';
import { bytesToFormattedSize } from 'utils/utils';

const SizeTemplate = ({ rowData }) => {
  if (rowData?.entry_type === 'folder') {
    return <span className="text-muted">-</span>;
  }

  const hasSize = typeof rowData?.size !== 'undefined' && rowData?.size !== null;
  return (
    <span className="text-muted">
      <span className="p-column-title text-break">File Size</span>
      {hasSize ? bytesToFormattedSize(rowData.size) : '-'}
    </span>
  );
};

export default SizeTemplate;
